import { render, staticRenderFns } from "./buttonSearch.vue?vue&type=template&id=13fed927"
import script from "./buttonSearch.vue?vue&type=script&lang=js"
export * from "./buttonSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports